import { checkIfTextShouldBeFolded } from './fold_seo_text/check_if_text_should_be_folded';

export const foldSEOText = () =>
    $('.brand-information, .brand-pattern-contents').foldableText(
        checkIfTextShouldBeFolded(),
        'brand-information-toggle-text'
    );
